export { default as EmojiSadSolidIcon } from './EmojiSadSolidIcon';
